/**
 * @generated SignedSource<<b2006b58ceeaf0d8aa173d9acc9cb7e1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useContentBasicInfoFragment$data = {
  readonly id: string | null | undefined;
  readonly status: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly title: string | null | undefined;
  readonly type: string | null | undefined;
  readonly " $fragmentType": "useContentBasicInfoFragment";
};
export type useContentBasicInfoFragment$key = {
  readonly " $data"?: useContentBasicInfoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentBasicInfoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useContentBasicInfoFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "Content"
};

(node as any).hash = "c75429b09fee9e0b10f7ca8e827e75a3";

export default node;
